import { Injectable } from '@angular/core';
 
import "rxjs/add/operator/map"
  
import { AppSettings } from './app.setting';
 import { Secteur } from '../entity/prospect';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
 

@Injectable()
export class SecteurService {
  private baseUrl: string = environment.restApi+'secteur';
  secteurs: Secteur[];

  constructor( private httpClient:HttpClient) {

  }

  

  getAll(): Observable<Secteur[]> {
    let secteur$ = this.httpClient
      .get<Secteur[]>(this.baseUrl ) ;
    return secteur$;
  }


  private getHeaders() {
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    return headers;
  }
  findSecteurbydesignation (term: string) : Observable<Secteur[]>{
    if(term)
    return this.httpClient
                .get<Secteur[]>(`${this.baseUrl}/findSecteurbydesignation/`+term   )  ;
    
  } 
 
  create(secteur :Secteur ): Observable<Response> {
    return this.httpClient.post<Response>(`${this.baseUrl}` , JSON.stringify(secteur) );
  }
  save(secteur :Secteur ): Observable<Response> {
    
      return this.httpClient.put<Response>(`${this.baseUrl}/`+secteur.secteurId, JSON.stringify(secteur) );
    }
    private handleErrorPromise (error: Response | any) {
      console.error(error.message || error);
      return Promise.reject(error.message || error);
      }
}

 
 

 